import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleCardsSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-site">
        <div className="text-center mb-10">
          <span className="inline-block text-accent-600 text-sm font-medium tracking-wider uppercase">/ Articles</span>
          <h2 className="mt-3 text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            Latest Mulebuy Spreadsheet Guides
          </h2>
          <p className="mt-3 text-foreground-500 text-sm max-w-xl mx-auto">
            In-depth articles covering everything you need to know about using the updated Mulebuy Spreadsheet effectively
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="cursor-pointer group bg-white border border-background-200 rounded-2xl overflow-hidden hover:border-accent-300 hover:shadow-lg transition-all duration-300 flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[3/2]">
                <img
                  src={article.thumbnailUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs text-accent-600 font-medium bg-accent-50 px-2 py-0.5 rounded-full">
                    {article.readTime}
                  </span>
                  <span className="text-xs text-foreground-400">June 2026</span>
                </div>
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 group-hover:text-accent-700 transition-colors duration-200 leading-snug">
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-4 pt-3 border-t border-background-100 flex items-center gap-1.5 text-accent-600 text-sm font-medium">
                  Read Article
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}